module.exports = __webpack_public_path__ + "f2679e0831338ade452ad3143ebb48ac.svg";